import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const providerServiceApi = createApi({
    reducerPath: 'providerServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Provider'],
    endpoints: (builder) => ({

        getAllProvider: builder.query({
            query: () => `/v1/provider`,
            providesTags: ['Provider'],
        }),

        createProvider: builder.mutation({
            query: (values) => ({
                url: `/v1/provider`,
                method: 'POST',
                body: values,
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Provider'],
        }),

        updateProvider: builder.mutation({
            query: ({id, ...values}) => ({
              url: `/v1/provider/${id}`,
              method: 'PUT',
              headers: {
                'authorization': token,
                'Content-Type': 'application/json',
            },
              body: values,
            }),
            invalidatesTags: ['Provider'],
          }),

        deleteProvider: builder.mutation({
            query: (id) => ({
                url: `/v1/provider/${id}`,
                method: 'DELETE',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Provider'],
        }),
    }),
});

export const {useGetAllProviderQuery, useCreateProviderMutation, useDeleteProviderMutation, useUpdateProviderMutation } = providerServiceApi;